import { createSlice } from "@reduxjs/toolkit";

interface AuctionState {
    level: number,
    acceptOpen: boolean,
    upAuctionFinish: boolean, // Đã đấu giá xong, xác định người trúng đấu giá trong trường hợp trả giá lên
    checkWinTriggered: boolean, // Đã kiểm tra trạng thái trúng đấu giá
    declinedWin: boolean, // Đã từ chối trả giá
    stopCountdown: boolean, // Dừng đếm ngược
    downPaymentUserAccepted: boolean // Hết thời gian rút lại giá hoặc người dùng đã ấn xác nhận trúng trong trường hợp đặt giá xuống
    skippedRound: boolean, // Người dùng có bỏ qua một vòng trả giá hay không 
}

const initialState: AuctionState = {
    level: 0,
    acceptOpen: false,
    upAuctionFinish: false,
    checkWinTriggered: false,
    declinedWin: false,
    stopCountdown: false,
    downPaymentUserAccepted: false,
    skippedRound: false,
}

export const auctionSlice = createSlice({
    name: 'auction',
    initialState,
    reducers: {
        setDefault: () => initialState,
        setLevel: (state: AuctionState, action: { payload: number }) => {
            state.level = action.payload;
        },
        toggleAcceptOpen: (state: AuctionState, action: { payload: boolean }) => {
            state.acceptOpen = action.payload;
        },
        setCheckWinTrigger: (state: AuctionState, action: { payload: boolean }) => {
            state.checkWinTriggered = action.payload;
        },
        setUpAuctionFinish: (state: AuctionState, action: { payload: boolean }) => {
            state.upAuctionFinish = action.payload;
        },
        setDeclinedWin: (state: AuctionState, action: { payload: boolean }) => {
            state.declinedWin = action.payload;
        },
        setStopCountdown: (state: AuctionState, action: { payload: boolean }) => {
            state.stopCountdown = action.payload;
        },
        setDownPaymentUserAccepted: (state: AuctionState, action: { payload: boolean }) => {
            state.downPaymentUserAccepted = action.payload;
        },
        setSkippedRound: (state: AuctionState, action: { payload: boolean }) => {
            state.skippedRound = action.payload;
        },
    }
})

export const { setLevel, toggleAcceptOpen, setUpAuctionFinish, setDefault,
    setCheckWinTrigger, setDeclinedWin, setStopCountdown, setDownPaymentUserAccepted, setSkippedRound } = auctionSlice.actions;
export default auctionSlice.reducer;